import { reactive } from "vue";
import { setIsLoading as setIsLoadingApp } from "../../../../app.logic";
import store from "../../../../store";
import { createLoading } from "../../../../utils/loading";
import { createManageExportCsv, createManageSelect, createPage } from "../../../../utils/page";
import { createColumns } from "./user.section";

export const { isLoading, setIsLoading } = createLoading();

export const actionPrefix = "resource/v1/security/user";
export const routerPrefix = "officer-users";

export const callCustomsSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/customsSearch`, { criteria });
export const callCustomsSave = ({ form }) => store.dispatch(`${actionPrefix}/customsSave`, { data: form });

export const onSearch = ({ page }) => {
    const where = page.where || [];
    const sort = page.sort || [];
    setIsLoading(true);
    window.onSearch?.({ page });
    return callCustomsSearch({ criteria: { ...page, data: [], where, sort } })
        .then(page => (state.page = { ...page, where, sort }))
        .finally(() => setIsLoading(false));
};

export const onClickRequest = ({ callRequest }) => {
    setIsLoadingApp(true);
    return callRequest()
        .then(() => onSearch({ page: state.page }))
        .finally(() => setIsLoadingApp(false));
};

export const initState = ({ props }) => {
    const menuContext = props.menuContext;
    state.manages = [createManageSelect({ menuContext }), createManageExportCsv({ menuContext })];
    state.manageExtras = [];
    state.rowActions = [];
};

export const state = reactive({
    columns: createColumns(),
    page: createPage({
        options: {
            select: [
                "*",
                "refDepartment.*",
                "refJobPosition.*",
                "refDocumentTypePerson.*",
                "refOfficerType.*",
                "refOfficerLv.*",
                "refStatus.*",
                "refLastRequest7.refRequestType.*"
            ],
            children: [
                {
                    name: "refLastRequest7.statuses",
                    asName: "refLastRequest7.lastStatus.approve",
                    select: ["**"],
                    page: 0,
                    size: 1,
                    where: [
                        {
                            name: "refStatus.key",
                            type: "String",
                            operator: "=",
                            value: "approve"
                        }
                    ],
                    sort: [{ name: "createDate", type: "DESC" }]
                }
            ]
        }
    }),
    tableOptions: { search: { activeKey: "Search" } }
});
